import { AUTH } from "../actions/auth"

export default function reducer(state = null, { type, payload }) {
  // eslint-disable-next-line security/detect-possible-timing-attacks -- comparing Redux action types is not timing-sensitive
  if (type === AUTH) {
    return payload
  }
  return state
}
